import { Component } from "react";

class FormComponent extends Component {
  constructor() {
    super();

    this.state = {isValidation: false}

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onChange(e) {
    let lookup = e.target.id.split(".");
    const field = lookup[lookup.length -1];
    lookup.pop() // remove last item

    let object = this.state.object;
    const errors = this.state.errors

    let obj = object;
    for (const f of lookup) {
      obj = obj[f];
    }

    if (e.target.type === "checkbox") {
      obj[field] = e.target.checked;
    } else if (e.target.type === "number") {
      obj[field] = parseInt(e.target.value, 10);
    } else {
      obj[field] = e.target.value;
    }

    this.setState({
      object: object,
      errors: { ...errors, [field]: null },
    })
  }

  async onBlur(e) {
    try {
      const { id, value, required } = e.target
      const rules = this.validations[id]

      if (rules) {
        let error = null
        if (value || required) {
          for (const rule in rules) {
            switch (rule) {
              case "regexp":
                const regexp = rules[rule]
                if (!regexp.test(value)) error = "Format is wrong!"
                break
              case "max":
                const max = rules[rule]
                if (value > max) error = `Max value is ${max}`
                break
              case "min":
                const min = rules[rule]
                if (value < min) error = `Min value is ${min}`
                break
              case "async":
                const checker = rules[rule]
                this.setState((prev) => ({ ...prev, isValidation: true }))
                const isExist = await checker(value)
                this.setState((prev) => ({ ...prev, isValidation: false }))
                if (isExist) error = "Already exists!"
                break
              default: break
            }
          }
        }
        const errors = { ...this.state.errors, [id]: error }
        this.setState((prev) => ({ ...prev, errors }))
      }
    }
    catch (e) { console.debug("onBlur", e) }
  }

  onSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(this.state.object);
  }

  componentDidMount() {
    this.setState({
      object: this.props.object || {},
    });
  }
componentWillUnmount(){
    this.setState({
    object:  {},
  });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.object !== this.props.object) {
      this.setState({
        object: this.props.object || {},
      });
    }
  }

  addKV = (name) => {
    return (e) => {
      e.preventDefault();

      let kvs = this.state[name];
      kvs.push({});

      let obj = {};
      obj[name] = kvs;

      this.setState(obj);
    };
  }

  onChangeKV = (name) => {
    return (index, obj) => {
      let kvs = this.state[name];
      let object = this.state.object;

      kvs[index] = obj;

      object[name] = {};
      kvs.forEach((objj, i) => {
        object[name][objj.key] = objj.value;
      });

      let ss = {
        object: object,
      };
      ss[name] = kvs;

      this.setState(ss);
    };
  }

  onDeleteKV = (name) => {
    return (index) => {
      let kvs = this.state[name];
      let object = this.state.object;

      kvs.splice(index, 1);

      object[name] = {};
      kvs.forEach((obj, i) => {
        object[name][obj.key] = obj.value;
      });

      let ss = {
        object: object,
      };
      ss[name] = kvs;

      this.setState(ss);
    };
  }
}

export default FormComponent;
